import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle'
import { Box, IconButton } from '@mui/material'
import { useEffect, useState } from 'react'
interface CollapsableDataPanelProps {
    title: JSX.Element
    content: JSX.Element
    forceOpen?: boolean
}

const CollapsableDataPanel = (props: CollapsableDataPanelProps) => {
    const { title, content, forceOpen } = props
    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (forceOpen) setOpen(forceOpen)
    }, [forceOpen])

    const renderDropdown = () => {
        if (!forceOpen) {
            return (
                <IconButton onClick={() => setOpen(!open)} sx={{ marginLeft: 'auto' }}>
                    <ArrowDropDownCircleIcon
                        sx={{ margin: 'auto', rotate: open ? '180deg' : '0deg' }}
                    />
                </IconButton>
            )
        }
    }

    return (
        <Box
            style={{
                minHeight: 'fit-content',
                minWidth: 'fit-content',
                padding: '30px',
                borderRadius: '10px',
                backgroundColor: '#F2F6F9',
            }}
        >
            <Box sx={{ display: 'flex' }}>
                <Box sx={{ margin: 'auto', display: 'flex', width: '100%' }}>
                    <Box>{title}</Box>
                    {renderDropdown()}
                </Box>
            </Box>
            <Box
                sx={{ visibility: open ? 'visible' : 'collapse', marginTop: open ? '20px' : '0px' }}
            >
                {content}
            </Box>
        </Box>
    )
}

export default CollapsableDataPanel
